import React, { useState } from 'react';
import { ButtonClean, Icon, Tooltip, useCopyToClipboard } from '@fourthwall/components';
import { DuplicateIcon, PreviewOnIcon, TickIcon } from '@fourthwall/icons';
import * as S from './CredentialDisplay.styled';
export const CredentialDisplay = ({ label, value, copyable = false, onReveal, maxDisplayLength = 50, }) => {
    const { isCopied, copyToClipboard } = useCopyToClipboard();
    const [revealed, setRevealed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [finalValue, setFinalValue] = useState(value);
    const revealable = !!onReveal;
    const handleReveal = async () => {
        if (onReveal) {
            setLoading(true);
            try {
                const secret = await onReveal();
                setFinalValue(secret);
                setRevealed(true);
            }
            finally {
                setLoading(false);
            }
        }
    };
    const displayValue = revealable && !revealed ? '••••••••••••••••••••••••' : finalValue || 'No value';
    const truncatedDisplayValue = displayValue.length > maxDisplayLength
        ? `${displayValue.substring(0, maxDisplayLength)}...`
        : displayValue;
    return (React.createElement(S.Container, null,
        React.createElement(S.HMACContainer, null,
            React.createElement(S.HMACKeyLabel, null,
                label,
                ": "),
            React.createElement("div", null, truncatedDisplayValue || `No ${label}`),
            copyable && finalValue && (React.createElement("div", null, isCopied ? (React.createElement(Tooltip, { reference: React.createElement(Icon, { component: TickIcon, height: 12 }) }, "Copied!")) : (React.createElement(Tooltip, { reference: React.createElement(ButtonClean, { label: "", icon: DuplicateIcon, onClick: () => copyToClipboard(finalValue) }) }, "Copy")))),
            revealable && !revealed && (React.createElement("div", null,
                React.createElement(Tooltip, { reference: React.createElement(ButtonClean, { label: "Reveal", icon: PreviewOnIcon, onClick: handleReveal, disabled: loading }) }, loading ? 'Loading...' : 'Reveal'))))));
};
